module.exports = "<vrm-header />\n<div class=\"container\">\n    <vrm-add-installation v-props-context='addInstallation'></vrm-add-installation>\n</div>\n";